<script>
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Modal,
    InputGroup
  },

  computed: {
    street: {
      get() {
        return this.$store.state.newAddress.street;
      },
      set(value) {
        this.$store.dispatch("newAddress/setStreet", value);
      }
    },
    streetNumber: {
      get() {
        return this.$store.state.newAddress.streetNumber;
      },
      set(value) {
        this.$store.dispatch("newAddress/setStreetNumber", value);
      }
    },
    zipCode: {
      get() {
        return this.$store.state.newAddress.zipCode;
      },
      set(value) {
        this.$store.dispatch("newAddress/setZipCode", value);
      }
    },
    complement: {
      get() {
        return this.$store.state.newAddress.complement;
      },
      set(value) {
        this.$store.dispatch("newAddress/setComplement", value);
      }
    },
    reference: {
      get() {
        return this.$store.state.newAddress.reference;
      },
      set(value) {
        this.$store.dispatch("newAddress/setReference", value);
      }
    },

    ...mapState("newAddress", ["city", "district"])
  },

  methods: {
    async confirm() {
      try {
        let valid = await this.$validator.validateAll();
        if (!valid)
          throw "Ops, algum dado está incorreto! Verifique e tente novamente!";
        this.$emit("next");
      } catch (e) {
        this.$toast.error(e);
      }
    }
  }
};
</script>

<template>
  <modal
    title="CONFIRME OS DADOS"
    subtitle="Caso necessário, informe os dados adicionais do seu endereço."
    size="md"
  >
    <template slot="body">
      <div class="form-group">
        <InputGroup
          :error="errors.first('rua')"
          v-model="street"
          v-validate="'required|max:255'"
          label="rua"
        />

        <InputGroup
          :error="errors.first('numero')"
          v-model="streetNumber"
          v-validate="'required|numeric|max:31'"
          name="numero"
          label="número"
        />

        <InputGroup
          :error="errors.first('complemento')"
          v-model="complement"
          v-validate="'min:2|max:255'"
          label="complemento"
        />
      </div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('cidade')"
          v-model="city.display_name"
          label="cidade"
          disabled
        />

        <InputGroup
          :error="errors.first('uf')"
          v-model="city.state.code"
          label="uf"
          disabled
        />

        <InputGroup
          :error="errors.first('bairro')"
          v-model="district.display_name"
          label="bairro"
          disabled
        />
      </div>

      <div class="form-group">
        <InputGroup
          :error="errors.first('cep')"
          v-model="zipCode"
          v-validate="'required|length:8|numeric'"
          label="cep"
        />

        <InputGroup
          :error="errors.first('referencia')"
          v-model="reference"
          v-validate="'min:5|max:255'"
          name="referencia"
          label="referência"
        />
      </div>
    </template>

    <template slot="footer">
      <div class="btn bg-gray" @click="$emit('prev')">voltar</div>
      <div class="btn bg-purple" @click="confirm()">confirmar</div>
    </template>
  </modal>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/DataConfirmation.vue